import {
    SEND_ADELANTO,
    SEND_ADELANTO_RESPONSE,
    SEND_ADELANTO_ERROR,
    RESET_SEND_ADELANTO,
} from './adelanto.actions';

const initialState = {
    /*
     * Status of the most recent "Enviar NEX" call.
     * Mirrors the shape of contract.setContractStatus so existing
     * StatusModal/IndStatusModal components can render it without adapters.
     */
    sendAdelantoStatus: {
        success: false,
        loading: false,
        error: false,
        message: '',
        lastResponse: null,
    },
};

const adelantoReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEND_ADELANTO:
        case SEND_ADELANTO_RESPONSE:
        case SEND_ADELANTO_ERROR:
            return {
                ...state,
                sendAdelantoStatus: {
                    success: action.type === SEND_ADELANTO_RESPONSE,
                    loading: action.type === SEND_ADELANTO,
                    error: action.type === SEND_ADELANTO_ERROR,
                    message:
                        action.type === SEND_ADELANTO_ERROR &&
                        (action?.error?.data
                            ? Object.values(action?.error?.data)[0][0]
                            : action?.error?.message || action?.error),
                    lastResponse:
                        action.type === SEND_ADELANTO_RESPONSE
                            ? action.response
                            : state.sendAdelantoStatus.lastResponse,
                },
            };
        case RESET_SEND_ADELANTO:
            return {
                ...state,
                sendAdelantoStatus: initialState.sendAdelantoStatus,
            };
        default:
            return state;
    }
};

export default adelantoReducer;
